// extracted by mini-css-extract-plugin
export var cardIcon = "_9w-5";
export var cardIconUnframed = "_9w-9";
export var checkboxCard = "_9w-0";
export var checkboxCardSelected = "_9w-4";
export var disabled = "_9w-2";
export var interactive = "_9w-1";
export var outerBorder = "_9w-3";
export var spacerMedium = "_9w-8";
export var spacerSmall = "_9w-7";
export var spacerXsmall = "_9w-6";